import React, { useState, ReactNode, useContext } from "react";
import { ApiError } from "../../api/ApiClient";
import { FlowHeaderContext } from "./FlowHeaderContext";

export interface IHeaderWithProgressContext {
  isSaving: boolean;
  setIsSaving: (isSaving: boolean) => void;
  hasSaved: boolean;
  setHasSaved: (hasSaved: boolean) => void;
  saveError: ApiError | null;
  setSaveError: (saveError: ApiError | null) => void;
  progress: number;
  showStatic: boolean;
}

export const HeaderWithProgressContext =
  React.createContext<IHeaderWithProgressContext | null>(null);

export function useHeaderWithProgress() {
  const headerWithProgressContext = useContext(HeaderWithProgressContext);

  if (!headerWithProgressContext)
    throw new Error("No HeaderWithProgressContext found!");

  return headerWithProgressContext;
}

export function HeaderWithProgressProvider({
  children,
}: {
  children: ReactNode;
}) {
  const defaultProgress = 1;

  const [progress, setProgress] = useState(defaultProgress);
  const [showStatic, setShowStatic] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [hasSaved, setHasSaved] = useState(false);
  const [saveError, setSaveError] = useState<ApiError | null>(null);

  return (
    <HeaderWithProgressContext.Provider
      value={{
        isSaving,
        setIsSaving,
        hasSaved,
        setHasSaved,
        saveError,
        setSaveError,
        progress,
        showStatic,
      }}
    >
      <FlowHeaderContext.Provider value={{ setProgress, setShowStatic }}>
        {children}
      </FlowHeaderContext.Provider>
    </HeaderWithProgressContext.Provider>
  );
}
